<template>
    <div class="float-left mr-1">
        <span class="text-primary">
            <i
                class="fa fa-edit fa-lg icon-button"
                title="Atualizar Dotação Orçamentária"
                @click.stop="abrirModalAtualizarDotacao()"
            ></i>
        </span>
        <b-modal
            id="modalAtualizarDotacao"
            v-model="mostrarModalAtualizarDotacao"
            @show="preencherForm()"
        >
            <div slot="modal-title">
                Dotação Orçamentária -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
            <b-alert show>
                <span>
                    Dotação Orçamentária Atual:
                    <br />Centro de Custo:
                    <strong>{{ dotacao.codCCusto }} - {{ dotacao.nomeCCusto }}</strong>
                </span>
            </b-alert>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row v-if="mostrarCheckApostilamento">
                <b-col>
                    <b-form-group>
                        <label>
                            <strong>O quê deseja fazer ?</strong>
                        </label>
                        <b-form-radio-group
                            v-model="contratoApostilamento"
                            @change="alternaJustificativa($event)"
                        >
                            <b-form-radio value="0">
                                <strong>
                                    <span class="text-danger">Atualizar</span>
                                </strong>
                            </b-form-radio>
                            <b-form-radio value="1">
                                <strong>
                                    <span class="text-primary">Apostilar</span>
                                </strong>
                            </b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Centro de Custo</label>
                        <model-list-select
                            :list="unidades"
                            option-text="nomeCodCCusto"
                            option-value="codCCusto"
                            v-model="codCCusto"
                            @input="$v.codCCusto.$touch()"
                        ></model-list-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <!-- <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Projeto</label>
                        <b-form-select
                            :options="projetos"
                            v-model="codProjeto"
                            text-field="nome"
                            value-field="codProjeto"
                            @input="$v.codProjeto.$touch()"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Ação</label>
                        <b-form-select
                            :options="acoes"
                            v-model="codAcao"
                            text-field="nome"
                            value-field="codAcao"
                            @input="$v.codAcao.$touch()"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row> -->
            <b-row v-if="apostilamento || this.atualizacaoContrato()">
                <b-col sm="12">
                    <b-form-group>
                        <label>Justificativa {{labelJustificativa}}</label>
                        <b-form-textarea
                            v-model="justificativaApostilamento"
                            :rows="4"
                            @input="$v.justificativaApostilamento.$touch()"
                            :state="
                                $v.justificativaApostilamento.$error
                                    ? false
                                    : null
                            "
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A justificativa {{textoInfoJustificativa}} é
                            obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharModalAtualizarDotacao()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="desabilitarBtnSalvar"
                    @click.stop="confirmarSalvarDotacao()"
                    class="ml-1"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import ContratosServicos from './../ContratosServicos'
import UnidadesServicos from './../../rm/UnidadesServicos'
import ProjetosServicos from './../../rm/ProjetosServicos'
import AcoesServicos from './../../rm/AcoesServicos'
import { situacaoContrato } from '../SituacaoContrato'
import { ModelListSelect } from 'vue-search-select'

export default {

    components: {
        ModelListSelect
    },

    props: {
        dotacao: {
            type: Object,
            default: () => ({})
        },

        apostilamento: {
            type: Boolean,
            default: () => false
        },

        contrato: {
            type: Object,
            default: () => ({})
        },
    },

    data() {
        return {
            mostrarModalAtualizarDotacao: false,
            obterDotacoesAtualizadas: false,
            operacao: 'ATUALIZAÇÃO',
            erros: [],
            codCCusto: null,
            codProjeto: null,
            codAcao: null,
            unidades: [],
            projetos: [],
            acoes: [],
            justificativaApostilamento: '',
            contratoApostilamento: null,
            labelJustificativa: '',
            textoInfoJustificativa: ''
        }
    },

    methods: {
        obterUnidades() {
            this.$store.dispatch('addRequest')
            UnidadesServicos.obterUnidadesProjetosAcoesPorDotacao(
                // this.dotacao.idRateioComprometimento
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.unidades = response.data
                        // this.projetos = response.data.projetos
                        // this.acoes = response.data.acoes
                        this.codCCusto = this.dotacao.codCCusto
                        // this.codProjeto = this.dotacao.vcCodProjeto
                        // this.codAcao = this.dotacao.vcCodAcao
                    } else {
                        this.$toast.error(
                            response.errors,
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        abrirModalAtualizarDotacao() {
            this.mostrarModalAtualizarDotacao = true
        },

        fecharModalAtualizarDotacao() {
            this.mostrarModalAtualizarDotacao = false
            this.resetAtualizarDotacao()
            if (this.obterDotacoesAtualizadas) {
                this.$emit('obterDotacoesAtualizadas')
            }
        },

        resetAtualizarDotacao() {
            this.justificativaApostilamento = ''
            this.erros = []
            this.codCCusto = null
            this.unidades = []
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        preencherForm() {
            this.obterUnidades()
        },

        confirmarSalvarDotacao() {
            this.$swal({
                title: 'Dotação Orçamentária',
                html: `Confirma a atualização da dotação orçamentária?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvarDotacao()
                }
            })
        },

        salvarDotacao() {
            this.$store.dispatch('addRequest')
            let dotacaoDto = {
                idRateioComprometimento: this.dotacao.idRateioComprometimento,
                idContrato: this.$route.params.contratoId,
                codCCusto: this.codCCusto,
                nomeCCusto: this.unidades.find(p => p.codCCusto == this.codCCusto).nomeCCusto,
                // codProjeto: this.codProjeto,
                // codAcao: this.codAcao,
                justificativaApostilamento: this.justificativaApostilamento,
                isApostilamento: this.contratoApostilamento == 1 ? true : false
            }
            ContratosServicos.atualizarDotacaoContrato(dotacaoDto).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.obterDotacoesAtualizadas = true
                            this.registroSalvoComSucesso(response.data)
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        registroSalvoComSucesso(data) {
            this.$toast.success(
                'Registro salvo com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.fecharModalAtualizarDotacao()
        },

        registrosInalterados() {
            return (
                this.codCCusto === this.dotacao.codCCusto
            )
        },

        justificativaOk() {
            if (this.apostilamento || this.atualizacaoContrato()) {
                return this.justificativaApostilamento !== ''
            }
            return true
        },

        situacoesVigenteDistribuido() {
            return (
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE2 ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_DISTRIBUIDO ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_DISTRIBUIDO
            )
        },

        contratoElaboracao() {
            return (
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_EM_ELABORACAO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.PRE_CONTRATO_CONCLUIDO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO
            )
        },

        aditivarContrato() {
            return (
                this.contrato.idSituacaoContrato == situacaoContrato.ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO
            )
        },

        atualizacaoContrato() {
            return (this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.situacoesVigenteDistribuido())
        },

        alternaJustificativa(value) {
            this.contratoApostilamento = value
            if(this.contratoApostilamento == 1) {
                this.textoInfoJustificativa = 'do apostilamento'
                this.labelJustificativa = 'Apostilamento'
            } else {
                this.textoInfoJustificativa = ''
                this.labelJustificativa = ''
            }
        },

         verificaTiposAtualizacao() {
            if((this.apostilamento || this.atualizacaoContrato()) && this.contratoApostilamento != null) {
                return true
            } else if(this.contratoElaboracao() || this.aditivarContrato()) {
                return true
            }
            return false
        },

        alternaJustificativaPorAcesso() {
            if(this.$temAcessoView('CONT-ATUALIZAR-00') && this.$temAcessoView('CONT-APOST-02')) {
                this.contratoApostilamento = null
            } else if(this.$temAcessoView('CONT-ATUALIZAR-00')) {
                this.contratoApostilamento = 0
                this.alternaJustificativa(this.contratoApostilamento)
            } else if(this.$temAcessoView('CONT-APOST-02')) {
                this.contratoApostilamento = 1
                this.alternaJustificativa(this.contratoApostilamento)
            }
        }

    },

    created() {
        this.alternaJustificativaPorAcesso()
    },

    computed: {
        desabilitarBtnSalvar() {
            return this.$v.$invalid
        },

        mostrarCheckApostilamento() {
            return (
                this.atualizacaoContrato() && this.apostilamento
            )
        },
    },

    watch: {
        // codUnidade(newVal, oldVal) {
        //     if (newVal) {
        //         this.obterProjetos()
        //     }
        // },

        // codProjeto(newVal, oldVal) {
        //     if (newVal) {
        //         this.obterAcoes()
        //     }
        // }
    },

    validations: {
        IdRateioComprometimento: {
            registrosAlterados() {
                return !this.registrosInalterados()
            }
        },
        codCCusto: {
            required
        },
        justificativaApostilamento: {
            justificativaOk() {
                return this.justificativaOk()
            }
        },
        contratoApostilamento: {
            verficaTipoAtualizacao() {
                return this.verificaTiposAtualizacao()
            }
        }
    }
}
</script>
